export const hasLineBreak = (str: string) => {
    return /\r|\n/.exec(str);
};
